import React from "react";
import { FeatureBanner1, FeatureBanner2 } from "../assets";
import Header from "./Header";
import { FEATURES } from "../utils/dummyData";

const Feature = () => {
  return (
    <section className="mt-[2rem]">
      <Header
        title="Why Choose us"
        subtitle="Your Journey to Digital Excellence Starts Here — Trust, Expertise, and Unmatched Support Await"
      />
      <div className="grid grid-cols-1 md:grid-cols-2 md:gap-4">
        <div className="md:grid md:grid-cols-2 md:gap-4 md:mb-4 items-start justify-start">
          {FEATURES.map((feat, i) => (
            <div
              key={i}
              className={`flex md:gap-4 lg:p-4 max-w-[420px] rounded-md items-center mb-4 gap-4 md:min-h-[200px]`}
            >
              <div className={`border-2 border-br rounded-full p-2 h-min w-min`}>
                <div className={`${feat.cl} text-2xl md:text-3xl`}>{feat.icon}</div>
              </div>
              <div className="">
                <h3 className="card-title text-base md:text-2xl font-semibold">{feat.title}</h3>
                <p className="hidden md:block card-text">{feat.description}</p>
              </div>
            </div>
          ))}
        </div>
        <div className="relative banner-wrapper feature-banner">
          <figure className="features-banner one">
            <img
              src={FeatureBanner1}
              loading="lazy"
              alt="features"
              className=""
            />
          </figure>
          <figure className="absolute features-banner two -bottom-16 right-0">
            <img
              src={FeatureBanner2}
              loading="lazy"
              alt="features"
              className="w-[260px] md:w-full md:min-w-[300px] max-w-[460px] rounded-lg"
            />
          </figure>
        </div>
      </div>
    </section>
  );
};

export default Feature;
